<template>
  <div class="max-width">

    <Loading :show="loading" />

    <div :class="{disabled: loading}">

      <h1>GDPR-rensa</h1>

      <label>Välj datum att rensa från</label>
      <Dropdown
        prefixicon="calendar"
        prefixicon-validated="calendar-white"
        ref="dateDropdown"
        tabindex="0"
        :options="[]"
        :validated="false"
        :label="'' + formatDate(pickedStartDate) + ''"
        @clicked="datepickerRangeModal"
        :bold-label="false"
        @clicked-suffix="dateClear">
      </Dropdown>

      <div style="clear:both;"></div>

      <br><br>

      <div style="clear:both;"></div>

      <button class="btn" @click="clean">Rensa online-registret innan {{ formatDate(pickedStartDate) }}</button>

    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Dropdown from '@/components/components/Dropdown';
import Loading from '@/components/components/Loading';
import API from '@/classes/API';
import moment from 'moment';

export default {
  components: {
    Dropdown,
    Loading,
  },
  data() {
    return {
      validStartDates: [],
      pickedStartDate: null,
      loading: false,
    };
  },
  mounted() {
    this.validStartDates = [];

    const loopStart = moment().subtract(1, 'year').toDate();
    let current = loopStart;
    const end = moment().subtract(1, 'month').toDate();
    let next = null;

    if (!this.pickedStartDate) {
      this.pickedStartDate = moment().subtract(1, 'month').toDate();
    }

    while (current < end) {
      next = moment(current).add(1, 'days');
      this.validStartDates.push(next.format('YYYY-MM-DD'));
      current = next.toDate();
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    formatDate() {
      if (this.pickedStartDate) {
        return moment(this.pickedStartDate).format('D MMMM YYYY');
      }
      return 'Välj rensningsdag';
    },
    datepickerRangeModal() {
      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        pickedEndDate: null,
        onClose: this.selectDates,
        night: false,
        startDateOnly: true,
        allowPrevious: true,
        terminology: 'Välj',
        info: 'Välj datum',
        infoOnPicked: 'Välj slutdatum',
        showAllMonths: true,
      }]);
    },
    selectDates(start, end) {
      if (!start) {
        return;
      }
      this.pickedStartDate = start;
      this.pickedEndDate = end;
      if (!end) {
        this.pickedEndDate = start;
      }
    },
    dateClear() {
      this.pickedStartDate = null;
      this.pickedEndDate = null;
    },
    async clean() {
      this.loading = true;

      const { success } = await API.post('/orders/gdpr-cleanup', {
        start: this.pickedStartDate,
      });

      this.loading = false;

      return success;
    },
  },
  computed: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

.max-width
  max-width: 800px
  margin 0 auto
  text-align: center;
  margin-top 100px
.dropdown-wrapper
  margin auto
table
  width 100%
th, td
  text-align left
  padding 2px 5px 2px 15px
  //width 25%
  border-bottom 1px solid lightgrey
  vertical-align: top;
  input
    font-weight normal
tbody tr:last-child td
  padding-bottom 20px
tr
  &.success
    opacity: 0.3
  &.failed
    background-color: pink
input
  pading 2px 5px
</style>



// WEBPACK FOOTER //
// GdprCleanup.vue?2094b08c